import { useQuery } from "@tanstack/react-query";
import { fetchPublicPost } from "../../../services/b2b-social-apiServices";

const useGettingPost = (postId, password = null) => {

    const getPost = async (postId, password) => {
        const post = await fetchPublicPost(postId, password);
        return post;
    }

    const { data: post, isLoading, isError } = useQuery({
        queryKey: ['fetchPublicPost', postId],
        queryFn: () => getPost(postId, password),
        enabled: !!postId,
    });

    return { post, isLoading, isError };

}

export default useGettingPost;